import { Observable } from 'rxjs';
import { MenuEntryViewModel } from '@nimbus-library/features/menu/models/menu-entry.view-model';

export class MenuViewModel {
  public readonly entries: Array<MenuEntryViewModel>;
  public readonly footerEntries: Array<MenuEntryViewModel>;
  public readonly brand: MenuEntryViewModel;
  public readonly filter$: Observable<boolean>;
  public readonly separatorPositions: string[];

  public constructor(
    entries: Array<MenuEntryViewModel>,
    footerEntries: Array<MenuEntryViewModel>,
    brand: MenuEntryViewModel,
    filter$: Observable<boolean>,
    separatorPositions?: string[],
  ) {
    this.entries = entries;
    this.footerEntries = footerEntries;
    this.brand = brand;
    this.filter$ = filter$;
    this.separatorPositions = separatorPositions;
  }
}
